'use client';
import DynamicComponent from '@repo/ui/src/components/DynamicComponent';
import { appComponentDirectory } from '@utils/appComponentDirectory';
import React from 'react';
import { SeoProps } from '@repo/ui/src/types/seo';
import Seo from '@repo/ui/src/components/Seo';

interface PageProps {
  // TODO: lets type this
  contentRows?: Array<any>;
  seo?: SeoProps;
}

const Page = ({ contentRows = [], seo }: PageProps) => {
  return (
    <>
      {seo && <Seo {...seo} contentRows={contentRows.map((c) => c._meta?.schema)} />}
      {contentRows?.map((props, i: number) => (
        <DynamicComponent
          key={i}
          _componentTypes={appComponentDirectory}
          order={(contentRows?.length ?? 0) - i}
          {...props}
        />
      ))}
    </>
  );
};

export default Page;
